<template>
<div id="fillTagsImages" class="modal" v-if="showPopup">
    <div class="modal-content" @click.stop="" style="height:auto;">
        <div class="my-modal-header">
            <div style="padding-top: 6px;font-weight: bold;font-size: 22px;">Uploading Tags Images</div>
        </div>
        <div class="modal-body" style="padding:0;">
            <div class="row-input">Current Tag: {{tagName}}</div>
            <div class="row-input">({{index}}/{{maxCount}})</div>
            <progress :value="index" :max="maxCount" style="width:100%;">{{index}}</progress>

        </div>
        <div class="modal-footer" style="justify-content: center;">
            <div class="admin-btn" style="width: 50%;" @click="stop()">Stop</div>
        </div>
    </div>

</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { removeItemOnce } from '@/scripts/js/forgeService'
import { takeScreenshotForDbidsNoRestore } from '@/utils/forgeUtils';
import { postDataAsync } from '@/utils/mongoUtils';

export default {
    name: 'FillTagsImagesPopup',
    data() {
        return {
            index: 0,
            tagName: '',
            allDbIds: [],
            maxCount: 0,
            stopped: true,
        }
    },
    methods: {
        moveToNextTag() {
            if (this.stopped) return;

            if (this.maxCount == 0) {
                this.stop();
                this.$store.dispatch({ type: "alert_Forge", message: 'All existing tags have an image.' })
                return;
            }

            this.index++;

            if (this.index == this.maxCount) {
                this.stop();
                this.$store.dispatch('showSuccessfulMessage', { message: "Finished taking screenshots for all tags." })
                return;
            }

            // Get the current tag from the large list of automatic tags.
            let currentTag = this.allDbIds[this.index];

            let { id, dbid, nodesIds, nodeId } = currentTag;

            if (!dbid) dbid = nodeId || nodesIds;
            
            // Get the current tag from the small loaded list of automatic tags, if existing
            let tag = this.tags.filter(o => o.children && !!o.children.length).find(o => o.id == id)

            if (currentTag != null && currentTag.thumbnailUrl) {
                if (!tag.thumbnailUrl) tag.thumbnailUrl = currentTag.thumbnailUrl;

                this.moveToNextTag();

                return;
            }

            const instanceTree = this.$store.state.viewer?.model?.getInstanceTree();

            if (!instanceTree) {
                this.stop();
                this.$store.dispatch({ type: "alert_Forge", message: 'Please wait for the viewer to load.' })
                return;
            }

            this.tagName = Array.isArray(dbid) ? dbid.join(', ') : instanceTree.getNodeName(dbid);

            takeScreenshotForDbidsNoRestore(this.$store.state.viewer, dbid, base64 => {

                if (!this.uploadURL) return;

                this.requestedImagesId.push(id);
                
                postDataAsync(this.uploadURL, { image64: base64, assetId: this.$store.state.assetId, id: id },
                    url => {
                        if (tag) tag.thumbnailUrl = url;
                        if (currentTag) currentTag.thumbnailUrl = url;
                    },
                    null,
                    () => {
                        removeItemOnce(this.requestedImagesId, id);
                        
                        if (!this.requestedImagesId.length && this.stopped) {
                            this.$store.dispatch('showSuccessfulMessage', { message: "All Requested Images were Saved Successfully.", timeout: 2000 })
                        }
                    })

                this.moveToNextTag();
            })
        },
        stop() {
            this.stopped = true;
            if(this.fillingAutomaticTags)
                this.$store.commit('SET_FILLING_AUTOMATIC_TAGS_IMAGES', false)
            else if (this.fillingHarvesterTags) {
                this.$store.commit('SET_FILLING_HARVESTER_TAGS_THUMBNAILS', false)
                this.$store.commit('SET_HARVESTER_TAGS_TO_CAPTURE', [])
            } else if (this.fillingAMISTags)
                this.$store.commit('SET_FILLING_AMIS_TAGS_IMAGES', false)
            else 
                this.$store.commit('SET_FILLING_INSPECTIONS_IMAGES', false)
        },
    },
    watch: {
        "showPopup": {
            handler: function (newValue, oldValue) {
                if (newValue) {
                    this.index = -1;                    
                    this.stopped = false;

                    if (this.fillingHarvesterTags) {
                        this.allDbIds = this.$store.getters.GET_HARVESTER_TAGS_TO_CAPTURE;
                    } else if (this.fillingAutomaticTags) {
                        let selectedGroup = this.$store.getters["GET_SELECTED_AUTOMATIC_TAGS_GROUP"];

                        if (selectedGroup) {
                            if (!selectedGroup.length) this.allDbIds = [];
                            else this.allDbIds = this.$store.state.TAGS.allExistingAutomaticDbids.filter(t => selectedGroup.some(id => t.id == id)) ?? [];
                        } else {
                            this.allDbIds = this.$store.state.TAGS.allExistingAutomaticDbids.filter(t => !t.thumbnailUrl) ?? []
                        }
                    } else if (this.fillingAMISTags) {
                        this.allDbIds = this.$store.state.TAGS.allExistingAMISDbids.filter(t => !t.thumbnailUrl && !!t.children && !!t.children.length) ?? []         
                    } else {
                        this.allDbIds = this.$store.getters['GET_INSPECTIONS_TO_CAPTURE'].filter(t => !t.thumbnailUrl && !!t.children && !!t.children.length) ?? []         
                    }

                    this.maxCount = this.allDbIds.length;

                    this.moveToNextTag();
                }
            },
            deep: true
        },
    },
    computed: {
        showPopup() {
            return this.fillingHarvesterTags || this.fillingAutomaticTags || this.fillingAMISTags || this.fillingInspectionTags
        },
        fillingHarvesterTags(){
            return this.$store.getters['GET_FILLING_HARVESTER_TAGS_THUMBNAILS']
        },
        fillingAutomaticTags(){
            return this.$store.getters['GET_FILLING_AUTOMATIC_TAGS_IMAGES']
        },
        fillingInspectionTags () {
            return this.$store.getters['GET_FILLING_INSPECTIONS_IMAGES']
        },
        fillingAMISTags(){
            return this.$store.getters['GET_FILLING_AMIS_TAGS_IMAGES']
        },
        tags () {
            if (this.fillingAutomaticTags) return this.automaticTagsWithoutImages;
            if (this.fillingAMISTags) return this.amisTagsWithoutImages;
            if (this.fillingInspectionTags) return this.inspectionTagsWithoutImages;
            return [];
        },
        automaticTagsWithoutImages() {
            return this.$store.getters['GET_AUTOMATIC_TAGS'].filter(t => !t.thumbnailUrl);
        },
        amisTagsWithoutImages() {
            return this.$store.getters['GET_AMIS_TAGS'].filter(t => !t.thumbnailUrl);
        },
        inspectionTagsWithoutImages () {
            return this.$store.getters['GET_INSPECTIONS_TO_CAPTURE'].filter(t => !t.thumbnailUrl);
        },
        uploadURL () {
            if (this.fillingHarvesterTags) return "api/harvester/uploadThumbnailToTag";
            if (this.fillingAutomaticTags) return "api/equipments/uploadImageToAutomaticTag";
            if (this.fillingAMISTags) return "api/AMIS/uploadImageToAMISTag";
            if (this.fillingInspectionTags) return "api/forge/inspections/uploadImageToInspection";
            return "";
        },
        selectedGroup() {
            return this.$store.getters['GET_SELECTED_AUTOMATIC_TAGS_GROUP'];
        },
        requestedImagesId: {
            get() {
                return this.$store.getters['GET_REQUESTED_IMAGES_IDS']
            },

            set(value) {
                this.$store.commit("SET_REQUESTED_IMAGES_IDS", value);
            }
        }
    }
}
</script>

<style>
#fillTagsImages {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(1, 1, 1, .5);
}
#fillTagsImages .modal-content {
    width: 40vw;
    max-width: 720px;
    padding: 15px;
}
#fillTagsImages .row-input {
    padding-left: 0px;
} 
</style>
